export const getFormattedCurrency = (currency?: string) => {
  if (currency === 'MYR') {
    return 'RM';
  } else if (currency === 'SGD') {
    return '$';
  }
  return currency;
};
